export const selectAlarm = (state) => {
    const alarams = state.alarm?.result?.map(alaramID => state.alarm.entities[alaramID])
    const alarmGoingOff = alarams?.find(alarm => alarm.isFiring || alarm.isExpired || alarm.isComplete)
    return alarmGoingOff
}
export const selectAlarms = (state) => {
    return state.alarm?.result?.map(alaramID => state.alarm.entities[alaramID])
}
export const selectAlarmHistory = (state) => {
    if(state.alarm.result) {
        const alarm = state.alarm.result.map(alaramID => state.alarm.entities[alaramID])
        if(alarm.length > 0) {
            return alarm[0]?.alarmEvents
        }
    }
    return []
}